import { AxiosResponse } from "axios";

export enum CacheKey {
    VisitorIpInformation,
    VisitorChatHistory,
    UserCannedMessages,
    UserCannedMessagesNew,
    WebsitePushContent,
    WebsitePushPages1,
    UserChats,
    SmtpInfo
}

class CacheService {
    private storage: Map<string, any> = new Map<string, any>();

    getOrCreate = async (key: CacheKey, uniqueKey: string, callback: () => Promise<AxiosResponse<any>>,isCacheApply:boolean=true) => {

        var keyString = this.getUniqueKey(key, uniqueKey);

        var existingValue = this.storage.get(keyString);
        if (existingValue !== null && existingValue !== undefined && isCacheApply===true) {
            return existingValue;
        }

        const result = await callback();

        // Only if Request Response is 200
        if (result.status === 200) {
            this.storage.set(keyString, result);
        }

        return result;
    }

    clearVisitorInfo = (visitorId: string) => {
        var key1 = this.getUniqueKey(CacheKey.VisitorIpInformation, visitorId)
        var key2 = this.getUniqueKey(CacheKey.VisitorChatHistory, visitorId);

        this.storage.delete(key1);
        this.storage.delete(key2);
    }

    getUniqueKey = (key: CacheKey, id: string) => {
        return `${CacheKey[key]}_${id}`;
    }

    cacheSRV = (value: string,key:string) => {
        var existingValue = localStorage.getItem(key);
        if (value==existingValue) {
            return false;
        }
        else{
            localStorage.setItem(key,value)          
            return true; 
        }
    }
}

var cacheService = new CacheService();

export {
    cacheService
}
